/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


document.addEventListener('DOMContentLoaded', () => {
  const productImages = document.querySelector('.product__images');

  if (!productImages) return;

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        // If the node itself is a video
        if (node.nodeName === 'VIDEO') {
          node.removeAttribute('controls');
        }

        // Also check for videos inside the node
        const videos = node.querySelectorAll?.('video');
        if (videos?.length) {
          videos.forEach(video => {
            video.removeAttribute('controls');
          });
        }
      });
    });
  });

  observer.observe(productImages, {
    childList: true,
    subtree: true
  });
});
 

document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM fully loaded');

  const supportedPageIds = [
    'hydrafacial-montreal-beauties-lab',
    'extraction-signature-express-beauties-lab',
    'longevity-signature-facial-beauties-lab',
    'personalized-self-love-facial-beauties-lab',
    'express-facial-beauties-lab',
    'biologique-recherche-restructuring-and-smoothing-facial-beauties-lab',
    'biologique-recherche-lift-c-v-s-facial-treatment-beauties-lab',
    'biologique-recherche-seconde-peau-facial-beauties-lab',
    'microneedling-treatment-beauties-lab',
    'traitement-microneedling-beauties-lab'
  ];

  const currentId = document.body.id;

  if (!supportedPageIds.includes(currentId)) {
    console.log('Body ID not in supported pages, current:', currentId);
    return;
  }

  const productComponent = document.querySelector('product-component');
  if (!productComponent) {
    console.log('No <product-component> found');
    return;
  }

  // Original autoplay on page load, your old working code:
  const deferredMediaButton = productComponent.querySelector('deferred-media > button.deferred-media__poster');
  if (deferredMediaButton) {
    const scrollPos = window.scrollY;   // save current scroll
    deferredMediaButton.click();
    window.scrollTo(0, scrollPos);      // restore scroll

    const deferredMediaVideo = productComponent.querySelector('deferred-media > video');
    if (deferredMediaVideo) {
      deferredMediaVideo.muted = true;

      deferredMediaVideo.addEventListener('canplay', () => {
        console.log('Video can play, attempting to play');
        deferredMediaVideo.play().then(() => {
          console.log('Video is playing');
        }).catch(err => {
          console.warn('Play attempt failed:', err);
        });
      });
    } else {
      console.log('No <video> found inside <deferred-media>');
    }
  } else {
    console.log('No deferred-media poster button found inside <product-component>');
  }

  // New: autoplay on thumbnail click
  document.querySelectorAll('.product__thumb a').forEach(thumb => {
    thumb.addEventListener('click', () => {
      setTimeout(() => {
        const activeSlide = document.querySelector('.product__slide.media--active');
        if (!activeSlide) {
          console.log('No active slide found after thumb click');
          return;
        }

        if (activeSlide.dataset.type === 'video') {
          const deferredMedia = activeSlide.querySelector('deferred-media');
          if (!deferredMedia) {
            console.log('No deferred-media found in active slide after thumb click');
            return;
          }

          const posterButton = deferredMedia.querySelector('button.deferred-media__poster');
          if (posterButton) {
            posterButton.click();
          }

          const video = deferredMedia.querySelector('video');
          if (video) {
            video.removeAttribute('controls');
            video.muted = true;
            video.play().catch(err => {
              console.warn('Play failed after thumb click:', err);
            });
          }
        } else {
          console.log('Active slide after thumb click is not video');
        }
      }, 100);
    });
  });
});




document.addEventListener('DOMContentLoaded', () => {
  const hash = window.location.hash;

  if (!hash) return; // no anchor, nothing to do

  // Function to scroll to the target element
  const scrollToAnchor = () => {
    const target = document.querySelector(hash);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      target.focus({ preventScroll: true });
      return true;
    }
    return false;
  };

  // Try immediately
  if (!scrollToAnchor()) {
    // If element isn't ready yet, retry until it exists
    const interval = setInterval(() => {
      if (scrollToAnchor()) clearInterval(interval);
    }, 50); // checks every 50ms

    // Stop trying after 5 seconds in case of error
    setTimeout(() => clearInterval(interval), 5000);
  }
});

// Add instagram 'inapp' class to document
document.addEventListener('DOMContentLoaded', function() {
  if (navigator.userAgent.toLowerCase().includes('instagram')) {
    document.documentElement.classList.add('inapp');
  }
});



(function() {
  function calcSavings() {
    const items = document.querySelectorAll('.cart__item');
    let totalSavings = 0;

    items.forEach(item => {
      const priceEl = item.querySelector('ins .money');
      const compareEl = item.querySelector('del .money');
      const qtyEl = item.querySelector('input.cart__quantity-field');

      if (priceEl && compareEl && qtyEl) {
        const price = parseFloat(priceEl.textContent.replace(/[^\d.]/g, ''));
        const compare = parseFloat(compareEl.textContent.replace(/[^\d.]/g, ''));
        const qty = parseInt(qtyEl.value, 10) || 1;

        totalSavings += (compare - price) * qty;
      }
    });

    const container = document.getElementById('cart-savings');
    if (!container) return;

    const priceSpan = container.querySelector('.cart__total__price .money');
    if (totalSavings > 0) {
      container.style.display = 'flex';
      if (priceSpan) {
        priceSpan.textContent = '$' + totalSavings.toFixed(2);
      }
    } else {
      container.style.display = 'none';
    }
  }

  // Initial calculation
  document.addEventListener('DOMContentLoaded', calcSavings);

  // Observe cart changes
  const cartContainer = document.querySelector('.drawer__items, .cart__price__holder');
  if (cartContainer) {
    const observer = new MutationObserver(() => {
      calcSavings();
    });

    observer.observe(cartContainer, {
      childList: true,
      subtree: true
    });
  }

  // Optional: run after quantity changes or item removal
  const priceHolder = document.querySelector('.cart__price__holder');
  if (priceHolder) {
    priceHolder.addEventListener('change', calcSavings);
  }
})();


(function () {
  function setProductStickyVars() {
    // Only run on desktop
    if (window.innerWidth < 750) return;

    // Only run on product pages
    if (!document.body.classList.contains('template-product')) return;

    const content = document.querySelector('.product__page .form__wrapper.is-sticky');
    const header = document.querySelector('.theme__header');

    if (!content || !header) return;

    const headerHeight = header.offsetHeight;
    const contentHeight = content.offsetHeight;

    // Output CSS variables
    document.documentElement.style.setProperty(
      '--product-sticky-top',
      `${headerHeight}px`
    );

    document.documentElement.style.setProperty(
      '--product-sticky-height',
      `${contentHeight}px`
    );
  }

  window.addEventListener('load', setProductStickyVars);
})();

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.scroll-shadow-menu-links').forEach(el => {
    const drawer = el.closest('.drawer__menu'); // parent container to compare

    const updateScrollbarVisibility = () => {
      if (!drawer) return;

      // Show scrollbar if the container is smaller than the content
      if (el.scrollHeight > drawer.scrollHeight) {
        el.classList.remove('no-scroll'); // content overflows → show fake scrollbar
      } else {
        el.classList.add('no-scroll');    // content fits → hide scrollbar
      }
    };

    // Initial check
    updateScrollbarVisibility();

    // Update on resize (responsive)
    window.addEventListener('resize', updateScrollbarVisibility);
  });
});

(function () {
  var bookingAnchor = document.querySelector('.product__custom-code a[href*="booking.mangomint.com"]');

  if (!bookingAnchor) return;

  var bookingUrl = bookingAnchor.getAttribute('href');

  // Inject scoped CSS to hide the default submit block on service pages
  var style = document.createElement('style');
  style.textContent = '.product__submit {display: none !important;}';
  document.head.appendChild(style);

  function patchCartBar() {
    var cartBar = document.getElementById('cart-bar');
    if (!cartBar) return false;

    var submitWrapper = cartBar.querySelector('.cart-bar__submit');
    if (!submitWrapper) return false;

    if (submitWrapper.querySelector('.cart-bar__book-now')) return true;

    // Override the !important display:none on the wrapper
    submitWrapper.style.setProperty('display', 'block', 'important');

    // Hide the old buttons with !important
    submitWrapper.querySelectorAll('.product__submit__add').forEach(function (btn) {
      btn.style.setProperty('display', 'none', 'important');
    });

    var link = document.createElement('a');
    link.href = bookingUrl;
    link.target = '_blank';
    link.rel = 'noopener';
    link.style.cssText = 'width:100%; display:inline-block;';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'btn btn--solid btn--primary cart-bar__book-now';
    btn.style.cssText = [
      'width:100%',
      '--btn-border:#ff52f1',
      '--btn-bg:#ff52f1',
      '--btn-text:#ffffff',
      '--btn-border-hover:#ff39ef',
      '--btn-bg-hover:#ff39ef',
      '--btn-text-hover:#ffffff',
    ].join(';');

    btn.innerHTML = '<span class="btn__text">Book now</span>';
    link.appendChild(btn);
    submitWrapper.insertBefore(link, submitWrapper.firstChild);

    return true;
  }

  if (!patchCartBar()) {
    var attempts = 0;
    var interval = setInterval(function () {
      if (patchCartBar() || ++attempts >= 20) clearInterval(interval);
    }, 250);
  }
})();


/**
 * Change le titre (h1) et la description de la page collection
 * en fonction du tag actif dans le widget de filtres (.usf-refineby__body).
 *
 * - Ne s'exécute QUE sur une page collection.
 * - Ne s'applique QUE si UN SEUL filtre est actif.
 * - S'il y a 0 ou plusieurs filtres actifs -> on remet le titre/description
 *   d'origine de la collection.
 * - Détecte la langue via <html lang="...">, sinon EN par défaut.
 * - Le widget de filtres étant généré en AJAX, on observe le DOM pour
 *   réagir quand un filtre est ajouté/retiré (pas de rechargement de page).
 */
(function () {
  'use strict';

  function isCollectionPage() {
    // Ajuste si ton thème utilise une autre classe de body / structure d'URL
    return (
      document.body.classList.contains('template-collection') ||
      window.location.pathname.indexOf('/collections/') === 0
    );
  }

  if (!isCollectionPage()) return;

  var isFR = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;

  // Table de correspondance : clé = texte exact affiché dans le <b> du filtre
  // (EN et FR pointent vers le même objet pour couvrir les deux cas)
  var tagData = {};

  function addTag(en, fr, descEn, descFr) {
    var entry = {
      title: { en: en, fr: fr },
      description: { en: descEn, fr: descFr }
    };
    tagData[en] = entry;
    tagData[fr] = entry;
  }

  addTag(
    'Dryness & Dehydration',
    'Sécheresse & déshydratation',
    'Restore comfort and replenish moisture with formulas designed to deeply hydrate your skin. Discover essentials that help leave it softer, smoother and more supple.',
    'Redonne confort et hydratation à ta peau grâce à des formules conçues pour combler ses besoins en hydratation. Découvre des essentiels qui aident à la rendre plus douce, lisse et souple.'
  );

  addTag(
    'Redness & Sensitivity',
    'Rougeurs & sensibilité',
    'Soothe visible redness and bring comfort to sensitive skin with gentle, calming formulas. These essentials help reduce the look of irritation and support your skin\u2019s natural balance.',
    'Apaise les rougeurs visibles et redonne du confort à ta peau sensible grâce à des formules douces et apaisantes. Ces essentiels aident à réduire l\u2019apparence des irritations et à préserver l\u2019équilibre naturel de ta peau.'
  );

  addTag(
    'Wrinkles & Firmness',
    'Rides & fermeté',
    'Target the appearance of fine lines, wrinkles and loss of firmness with formulas designed to support smoother, firmer and plumper-looking skin.',
    'Cible l\u2019apparence des ridules, des rides et du manque de fermeté avec des formules conçues pour aider ta peau à paraître plus lisse, ferme et repulpée.'
  );

  addTag(
    'Glow & Dullness',
    'Éclat & teint terne',
    'Bring radiance back to your complexion with brightening formulas that help revive dull-looking skin and reveal a fresh, luminous glow.',
    'Redonne de l\u2019éclat à ton teint grâce à des formules illuminatrices qui aident à raviver ta peau et à révéler un teint plus frais et lumineux.'
  );

  addTag(
    'Dark Spots & Hyperpigmentation',
    'Taches pigmentaires & hyperpigmentation',
    'Target the appearance of dark spots and uneven tone with formulas designed to help brighten your complexion and promote more even-looking skin.',
    'Cible l\u2019apparence des taches pigmentaires et du teint irrégulier avec des formules conçues pour illuminer ton teint et aider ta peau à paraître plus uniforme.'
  );

  addTag(
    'Breakouts, Blackheads & Enlarged Pores',
    'Éruptions cutanées, points noirs & pores dilatés',
    'Help clarify congested skin with targeted formulas designed to reduce the appearance of breakouts, blackheads and enlarged pores while keeping your complexion balanced.',
    'Aide à clarifier ta peau avec des formules ciblées qui contribuent à réduire l\u2019apparence des éruptions cutanées, des points noirs et des pores dilatés, tout en préservant l\u2019équilibre de ton teint.'
  );

  function init() {
    var titleEl = document.querySelector('.collection__title .hero__title');
    var descEl = document.querySelector('.collection__title .hero__description');

    if (!titleEl || !descEl) return;

    var defaultTitle = titleEl.textContent.trim();
    var defaultDescription = descEl.textContent.trim();
    var lastSignature = null; // évite d'écrire dans le DOM inutilement

    function getActiveTagName() {
      var items = document.querySelectorAll('.usf-refineby__body .usf-refineby__item');
      if (items.length !== 1) return null;

      var bEl = items[0].querySelector('b');
      return bEl ? bEl.textContent.trim() : null;
    }

    function updateHero() {
      var tagName = getActiveTagName();
      var signature = tagName || '__default__';

      if (signature === lastSignature) return; // rien n'a changé
      lastSignature = signature;

      var data = tagName ? tagData[tagName] : null;

      if (data) {
        titleEl.textContent = isFR ? data.title.fr : data.title.en;
        descEl.textContent = isFR ? data.description.fr : data.description.en;
      } else {
        titleEl.textContent = defaultTitle;
        descEl.textContent = defaultDescription;
      }
    }

    // Premier passage (au cas où un filtre est déjà actif au chargement)
    updateHero();

    // Le widget de filtres se met à jour en AJAX -> on observe les
    // changements du DOM pour réagir sans recharger la page
    var debounceTimer = null;
    var observer = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(updateHero, 100);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init);
  }
})();

// Only show cartBar below product form
(function () {
  function setDisplay(el, value) {
    if (!el) return;
    el.style.setProperty('display', value, 'important');
  }

  function init() {
    var productPage = document.querySelector('.product__page');
    var cartBar = document.getElementById('cart-bar');
    if (!productPage || !cartBar) return;

    // Start hidden until we know the scroll position relative to the
    // product page section.
    setDisplay(cartBar, 'none');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // .product__page still visible in viewport -> hide cart bar.
        // Once it's fully scrolled out of view -> show cart bar.
        setDisplay(cartBar, entry.isIntersecting ? 'none' : 'block');
      });
    }, { threshold: 0 });

    io.observe(productPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
